import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

const Banner = () => {
  return (
    <div className=" relative w-full xl:h-screen max-h-[900px]">
      <div className=" absolute top-14 lg:top-24 right-1/2 translate-x-14 lg:translate-x-32">
        <img src="/images/circle.png" alt="장식용 원형 이미지" width={60} height={60} />
      </div>
      <div className=" absolute top-40 lg:top-48 right-0 lg:right-[calc((100%-var(--container)))]">
        <img src="/images/circle.png" alt="장식용 원형 이미지" width={120} height={120} />
      </div>
      <div className=" absolute bottom-48 -left-32 lg:-left-20">
        <img src="/images/circle.png" alt="장식용 원형 이미지" width={260} height={260} />
      </div>

      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        navigation={false}
        modules={[Autoplay]}
        className="mySwiper relative w-full h-full max-h-[1000px]"
      >
        <SwiperSlide>
          <BannerCard
            id={1}
            src="/images/banner1.webp"
            subTitle="서울 수도권 전지역 어디라도!"
            title="도어락·열쇠"
            redTitle="24시간"
            secTitle="해결!"
            tag1={["도어락고장", "도어락설치", "도어락교체"]}
            tag2={["24시열쇠", "24시출장열쇠"]}
            w={791}
            h={1027}
          />
        </SwiperSlide>
        <SwiperSlide>
          <BannerCard
            id={2}
            src="/images/banner2.webp"
            subTitle="무파손 도어락 · 열쇠 잠긴문 해결전문가"
            title="잠긴문 해결전문가"
            redTitle="SOS"
            secTitle="도어락프로!"
            tag1={["잠긴문해결", "무파손해결", "24시도어락"]}
            tag2={["출장도어락", "비밀번호분실해결"]}
            w={445}
            h={764}
          />
        </SwiperSlide>
        <SwiperSlide>
          <BannerCard
            id={3}
            src="/images/banner3.webp"
            subTitle="서울 수도권 전지역 1시간 이내 긴급출동"
            title="365일 언제든지!"
            redTitle="긴급출동!"
            tag1={["긴급출동", "갑자기문잠김", "도어락잠김"]}
            tag2={["도어락긴급해결", "열쇠긴급해결"]}
            w={540}
            h={744}
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

const BannerCard = ({
  id,
  src,
  subTitle,
  title,
  redTitle,
  secTitle,
  tag1,
  tag2,
  w,
  h,
}: {
  id: number;
  src: string;
  subTitle: string;
  redTitle: string;
  secTitle?: string;
  title: string;
  tag1: Array<string>;
  tag2: Array<string>;
  w: number;
  h: number;
}) => {
  return (
    <div className=" relative w-full h-full px-[calc((100%-var(--container))/2)] 3xl:px-[calc((100%-var(--container)-150px))] mt-28 xl:pt-20 3xl:mt-36 ">
      <div className="grid gap-4 lg:gap-8 mb-10 xl:mb-0">
        <p className="text-xl xl:text-2xl 3xl:text-3xl">{subTitle}</p>
        <div className="grid gap-3">
          <h2 className="manru text-5xl lg:text-6xl xl:text-8xl 2xl:text-[7rem] 3xl:text-9xl font-extralight">
            {title}
          </h2>
          <h2 className="manru text-5xl lg:text-6xl xl:text-8xl 2xl:text-[7rem] 3xl:text-9xl font-light">
            <span className="text-[#ff0000] font-semibold">{redTitle}</span>
            &nbsp;
            {secTitle}
          </h2>
        </div>
        <div className=" opacity-60">
          <div className="flex items-center gap-3">
            {tag1.map((v, i) => (
              <p key={i} className="text-base xl:text-xl 2xl:text-2xl">
                #{v}
              </p>
            ))}
          </div>
          <div className="flex items-center gap-3">
            {tag2.map((v, i) => (
              <p key={i} className="text-base xl:text-xl 2xl:text-2xl">
                #{v}
              </p>
            ))}
          </div>
        </div>
      </div>
      <div className=" lg:absolute top-0 right-[calc((100%-var(--container))/2)] 3xl:right-[calc((100%-var(--container)-150px))] w-full lg:w-fit h-full">
        <img
          src={src}
          alt="icon"
          width={w}
          height={h}
          className={
            id === 1
              ? "!relative w-auto h-full max-h-96 mx-auto lg:mx-0 xl:max-h-[calc(900px-150px)] 2xl:max-h-[calc(900px-100px)] object-contain "
              : "!relative w-auto h-full max-h-80 mx-auto lg:mx-0 xl:max-h-[calc(900px-340px)] 2xl:max-h-[calc(900px-280px)] object-contain "
          }
        />
      </div>
    </div>
  );
};

export default Banner;
